<template>
    <form class="tw-space-y-5" data-test-id="basic-user-details-form" @submit.prevent="onSubmit">
        <div>
            <l-input-text
                id="firstname"
                :label="$t('profile.edit.firstName')"
                type="text"
                :value.sync="form.firstname"
                :disabled="hasAllFieldsDisabled"
                class="tw"
            />
        </div>

        <div>
            <l-input-text
                id="lastname"
                :label="$t('profile.edit.lastName')"
                type="text"
                :value.sync="form.lastname"
                :disabled="hasAllFieldsDisabled"
                class="tw"
            />
        </div>

        <div>
            <l-input-text
                id="job-title"
                :label="$t('profile.edit.jobTitle')"
                type="text"
                :value.sync="form.teamRole.title"
                :disabled="hasAllFieldsDisabled"
                class="tw"
            />
        </div>

        <div>
            <l-input-text
                id="pronouns"
                :label="$t('profile.edit.pronouns')"
                type="text"
                :value.sync="form.pronouns"
                :disabled="this.isLoading"
                :optional="true"
                class="tw"
            />
        </div>

        <div>
            <l-select
                id="gender"
                :label="$t('profile.edit.gender')"
                :value.sync="form.gender"
                :disabled="hasAllFieldsDisabled"
                :options="genderSelectOptions"
                :optional="true"
                class="tw"
            />
        </div>

        <div>
            <l-date-picker
                id="birthday"
                :label="$t('profile.edit.birthday')"
                :value="form.birthday ? this.$moment(form.birthday, 'YYYY-MM-DD') : ''"
                :on-date-change="onUpdateBirthday"
                :disabled="hasAllFieldsDisabled"
                :is-full-width="true"
                :is-u-t-c="false"
                input-class=""
                class="tw"
            />
        </div>

        <l-text-alert
            v-if="hasError"
            class="tw-leading-none tw-text-sm"
            type="danger"
            data-test-id="error"
            :text="errorMessage"
        />

        <l-base-button type="submit" :button-types="['default', 'raised']" :disabled="isLoading">
            {{ $t("profile.edit.btnUpdateBasics") }}
        </l-base-button>
    </form>
</template>

<script>
import { mapGetters } from "vuex";

import LInputText from "@/components/LInputText";
import LTextAlert from "@/components/LTextAlert";
import LSelect from "@/components/LSelect";
import LBaseButton from "@/components/LBaseButton";
import LDatePicker from "@/components/LDatePicker";

export default {
    components: { LInputText, LTextAlert, LSelect, LBaseButton, LDatePicker },
    data() {
        return {
            hasError: false,
            errorMessage: "",
            isLoading: false,
            form: {
                firstname: "",
                lastname: "",
                teamRole: {
                    title: "",
                },
                pronouns: "",
                gender: "",
                birthday: "",
            },
            genderSelectOptions: Object.freeze([
                {
                    text: this.$t("profile.edit.optionUnset"),
                    value: "",
                },
                {
                    text: this.$t("profile.edit.optionMale"),
                    value: "male",
                },
                {
                    text: this.$t("profile.edit.optionFemale"),
                    value: "female",
                },
                {
                    text: this.$t("profile.edit.optionDiverse"),
                    value: "diverse",
                },
            ]),
        };
    },
    computed: {
        ...mapGetters({
            currentUser: "users/current/user",
            rights: "users/current/rights",
        }),
        hasAllFieldsDisabled() {
            return this.isLoading || this.rights.P_BLOCK_EDITS;
        },
    },
    created() {
        this.prefillForm();
    },
    methods: {
        prefillForm() {
            Object.assign(this.form, {
                firstname: this.currentUser.firstname ?? "",
                lastname: this.currentUser.lastname ?? "",
                teamRole: {
                    ...this.currentUser.teamRole,
                    title: this.currentUser.teamRole?.title ?? "",
                },
                pronouns: this.currentUser.pronouns ?? "",
                gender: this.currentUser.gender ?? "",
                birthday: this.currentUser.birthday ?? "",
            });
        },
        onUpdateBirthday(timestamp) {
            if (!timestamp) return;
            this.form.birthday = new Date(timestamp);
        },
        async onSubmit() {
            this.isLoading = true;
            this.hasError = false;

            try {
                await this.$store.dispatch("users/current/updateProfile", {
                    payload: {
                        scope: ["name", "title", "pronouns", "gender", "birthday"],
                        form: {
                            ...this.form,
                            birthday: this.form.birthday
                                ? this.$moment(this.form.birthday, "YYYY-MM-DD").format(
                                      "DD-MM-YYYY",
                                  )
                                : "",
                        },
                    },
                });

                this.prefillForm();
            } catch (err) {
                this.hasError = true;
                this.errorMessage = err.response?.data?.message ?? err.message;
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>
